const fileHelper = {
  /** Takes a string value, e.g. "My Big File" and turns it into a friendly value
   * to use to prepend to a file extension to make a full filename, producing something like
   * "my-big-file.xlsx"
   */
  createFilenameFromString: function (
    inputString: string,
    appendDateStamp: boolean | undefined = false
  ) {
    let output = inputString.replace(/[^a-z0-9]/gi, "-").toLowerCase();

    if (appendDateStamp) {
      const dateStamp = new Date()
        .toISOString()
        .split("T")[0]
        .replace(/-/g, "");
      output += `_${dateStamp}`;
    }

    return output;
  },

  /** e.g. "EB Level 1 + Global" → "EB-Level-1-Global-Members-20260615.xlsx" */
  buildUserGroupMembersExportFilename: function (groupName: string): string {
    let sanitized = (groupName ?? "").trim() || "user-group";
    sanitized = sanitized.replace(/\s+/g, "-");
    sanitized = sanitized.replace(/[\\/:*?"<>|+]/g, "");
    sanitized = sanitized.replace(/-+/g, "-").replace(/^-+|-+$/g, "");
    if (!sanitized) {
      sanitized = "user-group";
    }

    const d = new Date();
    const dateStamp = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
    return `${sanitized}-Members-${dateStamp}.xlsx`;
  },

  /** e.g. "User-Groups-Rules-20260716.xlsx" */
  buildUserGroupRulesExportFilename: function (): string {
    const d = new Date();
    const dateStamp = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
    return `User-Groups-Rules-${dateStamp}.xlsx`;
  },

  /** e.g. "Users-20260720.xlsx" */
  buildUsersExportFilename: function (): string {
    const d = new Date();
    const dateStamp = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
    return `Users-${dateStamp}.xlsx`;
  },
};

export default fileHelper;
